import { render, staticRenderFns } from "./ControleRegistroApi.vue?vue&type=template&id=4749d832&scoped=true&"
import script from "./controleRegistroApi.js?vue&type=script&lang=js&"
export * from "./controleRegistroApi.js?vue&type=script&lang=js&"
import style0 from "./ControleRegistroApi.vue?vue&type=style&index=0&id=4749d832&scoped=true&lang=css&"
import style1 from "./ControleRegistroApi.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749d832",
  null
  
)

export default component.exports